import { render } from "./DetailsPage.vue?vue&type=template&id=e504ded2"
import script from "./DetailsPage.vue?vue&type=script&lang=ts"
export * from "./DetailsPage.vue?vue&type=script&lang=ts"
script.render = render

export default script